module.exports = __webpack_public_path__ + "static/img/code_right.1afdde9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code_right.png
// module id = y0WQ
// module chunks = 30